import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, renderList as _renderList, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "resident-reports-ant" }
const _hoisted_2 = {
  key: 0,
  class: "resident-reports-ant__empty"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "resident-reports-ant__signature-tooltip" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "resident-reports-ant__signature resident-reports-ant__signature--unsigned"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = ["href"]

import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { message } from 'ant-design-vue';
import type { TableColumnsType } from 'ant-design-vue';
import { getAssetsPath } from '@/js/utils/getAssetsDir';
import { formatMatchCountSummary } from '@/js/utils/search-highlight';
import { initSearchInput, querySearchInput } from '@/js/utils/search-input';
import { getReportDetailHref } from '../resident-report-detail';
import { openResidentReportDrawer } from '../resident-report-drawer';
import {
  fetchReportDetail,
  fetchReportList,
  getReportArchiveUrl,
} from '../resident-report/report-api';
import { mapApiReportToEditPayload } from '../resident-report-detail/map-report-detail';

interface ReportListItem {
  id: number;
  createdAt: string;
  year: number;
  status?: string | null;
  isSigned?: boolean;
  fioSignatory?: string | null;
  certNumber?: string | null;
  dateSign?: string | null;
  nameOrganization?: string | null;
  certValidUntil?: string | null;
}

const DEFAULT_STATUS = 'Черновик';
const SEARCH_INPUT_ID = 'residentReportsSearch';

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const TABLE_SCROLL = { x: 720, y: 500 };
const SIGNED_ICON = getAssetsPath('/assets/images/icons/resident-lk/signed.svg');
const NOT_SIGNED_ICON = getAssetsPath('/assets/images/icons/resident-lk/not-signed.svg');
const PLUS_ICON = getAssetsPath('/assets/images/icons/plus-icon.svg');

const columns: TableColumnsType<ReportListItem> = [
  {
    title: '#',
    key: 'number',
    width: 50,
  },
  {
    title: 'Отчётный период',
    key: 'year',
    dataIndex: 'year',
    width: 140,
  },
  {
    title: 'Дата подачи',
    key: 'createdAt',
    dataIndex: 'createdAt',
    width: 130,
  },
  {
    title: 'Статус',
    key: 'status',
    dataIndex: 'status',
    width: 200,
    customCell: () => ({
      class: 'resident-reports-ant__status-cell',
    }),
  },
  {
    title: 'Эл. подпись',
    key: 'signature',
    dataIndex: 'isSigned',
    width: 150,
  },
  {
    title: '',
    key: 'actions',
    width: 48,
    align: 'right',
  },
];

const mockReports: ReportListItem[] = [
  { id: 1, createdAt: '2026-05-03T14:32:00', year: 2026, status: 'Черновик', isSigned: false },
  { id: 2, createdAt: '2025-05-03T10:11:00', year: 2025, status: 'Принят', isSigned: false },
  {
    id: 3,
    createdAt: '2024-05-03T12:00:00',
    year: 2024,
    status: 'На рассмотрении',
    isSigned: true,
    dateSign: '2026-05-03T12:00:00',
    certNumber: '098.765.432.1',
    fioSignatory: 'Константинов Е. П.',
    nameOrganization: 'ООО «Компания_название»',
    certValidUntil: '2026-05-03T12:00:00',
  },
  {
    id: 4,
    createdAt: '2023-05-03T09:40:00',
    year: 2023,
    status: 'Требует доработки',
    isSigned: false,
  },
  {
    id: 5,
    createdAt: '2022-05-03T16:20:00',
    year: 2022,
    status: 'Принят',
    isSigned: true,
    dateSign: '2026-05-03T16:20:00',
    certNumber: '098.765.432.1',
    fioSignatory: 'Константинов Е. П.',
    nameOrganization: 'ООО «Компания_название»',
    certValidUntil: '2026-05-03T16:20:00',
  },
  {
    id: 6,
    createdAt: '2021-05-03T11:25:00',
    year: 2021,
    status: 'Принят',
    isSigned: true,
    dateSign: '2026-05-03T11:25:00',
    certNumber: '098.765.432.1',
    fioSignatory: 'Константинов Е. П.',
    nameOrganization: 'ООО «Компания_название»',
    certValidUntil: '2026-05-03T11:25:00',
  },
  {
    id: 7,
    createdAt: '2020-05-03T13:10:00',
    year: 2020,
    status: 'Принят',
    isSigned: true,
    dateSign: '2026-05-03T13:10:00',
    certNumber: '098.765.432.1',
    fioSignatory: 'Константинов Е. П.',
    nameOrganization: 'ООО «Компания_название»',
    certValidUntil: '2026-05-03T13:10:00',
  },
  { id: 8, createdAt: '2019-05-03T15:45:00', year: 2019, status: 'Принят', isSigned: false },
  {
    id: 9,
    createdAt: '2018-05-03T10:30:00',
    year: 2018,
    status: 'Принят',
    isSigned: true,
    dateSign: '2026-05-03T10:30:00',
    certNumber: '098.765.432.1',
    fioSignatory: 'Константинов Е. П.',
    nameOrganization: 'ООО «Компания_название»',
    certValidUntil: '2026-05-03T10:30:00',
  },
  {
    id: 10,
    createdAt: '2017-05-03T09:15:00',
    year: 2017,
    status: 'Принят',
    isSigned: true,
    dateSign: '2026-05-03T09:15:00',
    certNumber: '098.765.432.1',
    fioSignatory: 'Константинов Е. П.',
    nameOrganization: 'ООО «Компания_название»',
    certValidUntil: '2026-05-03T09:15:00',
  },
];

const loading = ref(false);
const reports = ref<ReportListItem[]>([]);
const searchQuery = ref('');
let cleanupSearchInput: (() => void) | null = null;
let cleanupReportsReload: (() => void) | null = null;

const filteredReports = computed(() => {
  const query = searchQuery.value.trim().toLowerCase();

  if (!query) return reports.value;

  return reports.value.filter((report) => {
    const values = [
      formatReportYear(report.year),
      formatDate(report.createdAt),
      report.status || DEFAULT_STATUS,
      report.isSigned ? 'подписан' : 'не подписан',
    ];

    return values.some((value) => value.toLowerCase().includes(query));
  });
});

const isCompletelyEmpty = computed(
  () => !loading.value && reports.value.length === 0 && !searchQuery.value.trim(),
);

const hasActiveSearch = computed(() => Boolean(searchQuery.value.trim()));

function updateSearchSummary(): void {
  const summary = querySearchInput(document, SEARCH_INPUT_ID)?.summary;
  if (!summary) return;

  const query = searchQuery.value.trim();
  if (!query) {
    summary.hidden = true;
    summary.innerHTML = '';
    return;
  }

  summary.hidden = false;
  summary.innerHTML = formatMatchCountSummary(filteredReports.value.length, query);
}

function syncPageState(): void {
  const page = document.querySelector<HTMLElement>('.resident-reports-page');
  if (!page) return;

  page.classList.toggle('resident-reports-page--empty', isCompletelyEmpty.value);
}

watch([searchQuery, filteredReports], () => {
  updateSearchSummary();
});

function handleCreateReport(): void {
  openResidentReportDrawer('create');
}
onMounted(() => {
  bindSearchInput();
  bindReportsReload();
  loadReports();
});

onBeforeUnmount(() => {
  cleanupSearchInput?.();
  cleanupReportsReload?.();
});

async function loadReports(): Promise<void> {
  loading.value = true;

  try {
    const data = (await fetchReportList()) as ReportListItem[];
    reports.value = data.map(normalizeReportListItem);
  } catch {
    reports.value = mockReports.map(normalizeReportListItem);
  } finally {
    loading.value = false;
    syncPageState();
    updateSearchSummary();
  }
}

function normalizeReportListItem(item: ReportListItem): ReportListItem {
  return {
    ...item,
    isSigned: normalizeIsSigned(item.isSigned),
  };
}

function normalizeIsSigned(value: unknown): boolean {
  if (typeof value === 'boolean') {
    return value;
  }

  if (typeof value === 'number') {
    return value === 1;
  }

  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    return normalized === '1' || normalized === 'true' || normalized === 'y';
  }

  return false;
}

function isReportSigned(record: ReportListItem): boolean {
  return normalizeIsSigned(record.isSigned);
}

function getSignaturePopoverContainer(): HTMLElement {
  return document.body;
}

function bindSearchInput(): void {
  const elements = initSearchInput(document, {
    inputId: SEARCH_INPUT_ID,
    mode: 'server',
  });

  if (!elements) {
    return;
  }

  const syncSearchQuery = (): void => {
    searchQuery.value = elements.input.value;
    syncPageState();
    updateSearchSummary();
  };

  syncSearchQuery();
  elements.input.addEventListener('input', syncSearchQuery);
  elements.clearBtn.addEventListener('click', syncSearchQuery);

  cleanupSearchInput = () => {
    elements.input.removeEventListener('input', syncSearchQuery);
    elements.clearBtn.removeEventListener('click', syncSearchQuery);
    cleanupSearchInput = null;
  };
}

function bindReportsReload(): void {
  const reloadReports = (): void => {
    loadReports();
  };

  window.addEventListener('residentReports:changed', reloadReports);
  cleanupReportsReload = () => {
    window.removeEventListener('residentReports:changed', reloadReports);
    cleanupReportsReload = null;
  };
}

function getRowProps(record: ReportListItem): { onClick: () => void } {
  return {
    onClick: () => {
      window.location.href = getDetailHref(record.id);
    },
  };
}

async function handleEditReport(id: number): Promise<void> {
  try {
    const data = await fetchReportDetail(id);
    openResidentReportDrawer('edit', mapApiReportToEditPayload(id, data));
  } catch (error) {
    message.error(
      error instanceof Error ? error.message : 'Не удалось открыть отчёт для редактирования',
    );
  }
}

function getDetailHref(id: number): string {
  return getReportDetailHref(id);
}

function getDownloadHref(id: number): string {
  return getReportArchiveUrl(id);
}

function getSignatureTooltipItems(record: ReportListItem): Array<{ label: string; value: string }> {
  return [
    {
      label: 'Дата подписи',
      value: formatDate(record.dateSign || record.createdAt),
    },
    {
      label: 'Сертификат, №',
      value: record.certNumber || 'Не указан',
    },
    {
      label: 'Владелец',
      value: record.fioSignatory || 'Не указан',
    },
    {
      label: 'Компания',
      value: record.nameOrganization || 'Не указана',
    },
    {
      label: 'Срок действия сертификата',
      value: formatDate(record.certValidUntil || record.dateSign || record.createdAt),
    },
  ];
}

function formatDate(iso: string): string {
  if (!iso) return '';

  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;

  return date.toLocaleDateString('ru-RU');
}

function formatReportYear(year: number): string {
  return year ? `${year} г.` : '';
}

function getStatusModifier(status?: string | null): string {
  const normalized = (status || DEFAULT_STATUS).toLowerCase();

  if (normalized.includes('принят')) return 'accepted';
  if (normalized.includes('доработ')) return 'revision';
  if (normalized.includes('рассмотр')) return 'review';

  return 'draft';
}

return (_ctx: any,_cache: any) => {
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isCompletelyEmpty.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[5] || (_cache[5] = _createElementVNode("h3", { class: "resident-reports-ant__empty-title" }, "Нет отчетов", -1)),
          _cache[6] || (_cache[6] = _createElementVNode("p", { class: "resident-reports-ant__empty-text" }, "Вы ещё не создали ни одного отчета.", -1)),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary btn-medium",
            onClick: handleCreateReport
          }, [
            _createElementVNode("img", { src: _unref(PLUS_ICON) }, null, 8, _hoisted_3),
            _cache[4] || (_cache[4] = _createElementVNode("span", null, "Новый отчет", -1))
          ])
        ]))
      : (!hasActiveSearch.value || filteredReports.value.length)
        ? (_openBlock(), _createBlock(_component_a_table, {
            key: 1,
            class: "resident-reports-ant__table",
            columns: columns,
            bordered: true,
            "data-source": filteredReports.value,
            loading: loading.value,
            pagination: false,
            scroll: TABLE_SCROLL,
            "custom-row": getRowProps,
            "row-key": "id"
          }, {
            bodyCell: _withCtx(({ column, record, index }) => [
              (column.key === 'number')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(index + 1) + ". ", 1)
                  ], 64))
                : (column.key === 'year')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(formatReportYear(record.year)), 1)
                    ], 64))
                  : (column.key === 'createdAt')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createTextVNode(_toDisplayString(formatDate(record.createdAt)), 1)
                      ], 64))
                    : (column.key === 'status')
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 3,
                          class: _normalizeClass([
              'resident-reports-ant__status',
              `resident-reports-ant__status--${getStatusModifier(record.status)}`,
            ])
                        }, [
                          _cache[7] || (_cache[7] = _createElementVNode("span", {
                            class: "resident-reports-ant__status-dot",
                            "aria-hidden": "true"
                          }, null, -1)),
                          _createTextVNode(" " + _toDisplayString(record.status || DEFAULT_STATUS), 1)
                        ], 2))
                      : (column.key === 'signature')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                            (isReportSigned(record))
                              ? (_openBlock(), _createBlock(_component_a_popover, {
                                  key: 0,
                                  "overlay-class-name": "resident-reports-ant__signature-popover",
                                  placement: "bottomLeft",
                                  trigger: "hover",
                                  "mouse-enter-delay": 0.2,
                                  "get-popup-container": getSignaturePopoverContainer
                                }, {
                                  content: _withCtx(() => [
                                    _createElementVNode("dl", _hoisted_4, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getSignatureTooltipItems(record), (item) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: item.label,
                                          class: "resident-reports-ant__signature-tooltip-item"
                                        }, [
                                          _createElementVNode("dt", null, _toDisplayString(item.label), 1),
                                          _createElementVNode("dd", null, _toDisplayString(item.value), 1)
                                        ]))
                                      }), 128))
                                    ])
                                  ]),
                                  default: _withCtx(() => [
                                    _createElementVNode("span", {
                                      class: "resident-reports-ant__signature resident-reports-ant__signature--signed resident-reports-ant__signature--interactive",
                                      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
                                      onMouseenter: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                                    }, [
                                      _createElementVNode("img", {
                                        src: _unref(SIGNED_ICON),
                                        alt: "",
                                        "aria-hidden": "true"
                                      }, null, 8, _hoisted_5),
                                      _cache[8] || (_cache[8] = _createTextVNode(" Подписан ", -1))
                                    ], 32)
                                  ]),
                                  _: 2
                                }, 1024))
                              : (_openBlock(), _createElementBlock("span", _hoisted_6, [
                                  _createElementVNode("img", {
                                    src: _unref(NOT_SIGNED_ICON),
                                    alt: "",
                                    "aria-hidden": "true"
                                  }, null, 8, _hoisted_7),
                                  _cache[9] || (_cache[9] = _createTextVNode(" Не подписан ", -1))
                                ]))
                          ], 64))
                        : (column.key === 'actions')
                          ? (_openBlock(), _createBlock(_component_a_dropdown, {
                              key: 5,
                              trigger: ['click']
                            }, {
                              overlay: _withCtx(() => [
                                _createVNode(_component_a_menu, {
                                  class: "resident-reports-ant__actions-menu",
                                  onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_menu_item, {
                                      key: "edit",
                                      onClick: _withModifiers(($event: any) => (handleEditReport(record.id)), ["stop"])
                                    }, {
                                      default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                        _createTextVNode(" Редактировать ", -1)
                                      ]))]),
                                      _: 1
                                    }, 8, ["onClick"]),
                                    _createVNode(_component_a_menu_item, { key: "download" }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("a", {
                                          href: getDownloadHref(record.id),
                                          target: "_blank",
                                          rel: "noopener",
                                          class: "resident-reports-ant__actions-menu--link"
                                        }, [...(_cache[12] || (_cache[12] = [
                                          _createTextVNode(" Скачать ", -1),
                                          _createElementVNode("span", { class: "resident-reports-ant__actions-menu--zip" }, "(.zip)", -1)
                                        ]))], 8, _hoisted_8)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("button", {
                                  class: "resident-reports-ant__actions-btn",
                                  type: "button",
                                  "aria-label": "Действия с отчётом",
                                  onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
                                }, [...(_cache[10] || (_cache[10] = [
                                  _createElementVNode("i", {
                                    class: "bi bi-three-dots-vertical",
                                    "aria-hidden": "true"
                                  }, null, -1)
                                ]))])
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["data-source", "loading"]))
        : _createCommentVNode("", true)
  ]))
}
}

})